<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="astral-content-width astral-stack-l">
      <app-information-block [text]="'CONSUMPTION.IMPORT.IMPORT_FILE_DESCRIPTION'"></app-information-block>
      <section class="astral-section-surface">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <div class="astral-grid-span-2 astral-stack-s">
            <app-autocomplete-remote-paged
              [control]="form.controls['companyId']"
              [defaultSearch]="'*'"
              [service]="companyService"
            ></app-autocomplete-remote-paged>
            <app-single-file-upload
              (filesSelected)="filesSelected($event)"
              [allowedMimeTypes]="['.txt', '.csv', '.kim']"
              [fileValidator]="fileValidator"
            ></app-single-file-upload>
            <astral-input [control]="form.controls['fileName']"></astral-input>
          </div>
        </astral-layout-group>
      </section>
    </form>
  }
</section>
